module.exports = __webpack_public_path__ + "img/t4.71d575cf.jpg";